import { axios } from "lib/axios";
import { useMutation } from "react-query";

export const newVisitor = () => {
  return axios.post(`/visitors`);
};

export const useNewVisitor = ({ config } = {}) => {
  return useMutation({
    onMutate: async () => {},
    onError: (_, __, context) => {},
    onSuccess: () => {},
    ...config,
    mutationFn: newVisitor,
  });
};
